import "flickity/dist/flickity.pkgd.min.js";



// WEBPACK FOOTER //
// ./scripts/autoload/flickity.js